<template>
	<div class="row m-0 mt-3 wp_CollapseItemBorder">
		<div class="col-12 p-0">
			<div class="card p-3" style="margin: 0;">
				<a class="gift-head a-hover-unstyled d-flex justify-content-between"
							data-toggle="collapse"
							href="#collapsegiftapply"
							role="button"
							data-test="applyGiftCardFormLink"
							id="applyGiftCardFormLink"
				>
					<strong>
						<i class="fas fa-gift"
									data-test="applyGiftCardFormIcon"
									id="applyGiftCardFormIcon"></i> 	Apply Gift Card / Coupon Code
					</strong>
					<i class="fas fa-angle-up"
								data-test="applyGiftCardFormArrowIcon"
								id="applyGiftCardFormArrowIcon"></i>
				</a>
				<div class="container collapse p-0 mt-3"
									id="collapsegiftapply"
				>
					<div class="row m-0">
						<div class="col-12 p-0">
							<!-- TAB MENU -->
							<ul class="nav nav-tabs">
								<li class="nav-item">
									<a class="nav-link active"
												data-toggle="tab"
												href="#wp_giftCardTab"
												data-test="applyGiftCardFormCard"
												id="applyGiftCardFormCard"
									>
										Gift Card
									</a>
								</li>
								<li class="nav-item">
									<a class="nav-link"
												data-toggle="tab"
												href="#wp_couponCodeTab"
												data-test="applyGiftCardFormCoupon"
												id="applyGiftCardFormCoupon"
									>
										Coupon Code
									</a>
								</li>
							</ul>
							<!-- TAB MENU -->

							<!-- TAB CONTENT -->
							<div class="tab-content">
								<div id="wp_giftCardTab"
													class="container tab-pane active"
								>
									<br/>
									<form data-vv-scope="applyGiftCard">
										<div class="form-group width-reduce-large-device mb-0">
											<input
												type="text"
												class="form-control"
												id="giftCardNumberInput"
												aria-describedby="giftCardNumber"
												placeholder="Gift Card Number"
												name="gift-card-number"
												v-model="giftCardValidationData.giftCardNumber"
												v-validate="'required|alpha_num'"
												:class="(showApplyGiftCardError &&
                        errors.has('applyGiftCard.gift-card-number'))?'is-invalid':''"
												autocomplete="off"
												data-test="applyGiftCardFormCardNoInput"
											/>
										</div>
										<div
											class="invalid-feedback"
											v-if="(errors.has('applyGiftCard.gift-card-number') && showApplyGiftCardError)"
											style="display: block;"
											id="gift-card-email-error"
											data-test="applyGiftCardFormCardNoInputError"
										>{{ errors.first('applyGiftCard.gift-card-number') }}
										</div>
										<div class="form-group width-reduce-large-device mb-0 mt-2">
											<input
												type="password"
												class="form-control"
												id="giftCardPassCode"
												placeholder="Pin"
												name="gift-card-pin"
												v-model="giftCardValidationData.giftCardPin"
												v-validate="'required|alpha_num'"
												:class="(showApplyGiftCardError &&
                        errors.has('applyGiftCard.gift-card-pin'))?'is-invalid':''"
												autocomplete="off"
												data-test="applyGiftCardFormPinInput"
											/>
										</div>
										<div
											class="invalid-feedback mb-0"
											v-if="(errors.has('applyGiftCard.gift-card-pin') && showApplyGiftCardError)"
											style="display: block;"
											id="gift-card-pin-error"
											data-test="applyGiftCardFormPinInputError"
										>{{ errors.first('applyGiftCard.gift-card-pin') }}
										</div>
										<button
											type="submit"
											class="btn btn-primary btn-type-primary mt-3"
											@click.prevent="action('applyGiftCard')"
											data-test="applyGiftCardFormApplyBtn"
											id="applyGiftCardFormApplyBtn"
										>
											Apply
										</button>
									</form>
								</div>
								<div id="wp_couponCodeTab"
													class="container tab-pane fade"
								>
									<br/>
									<promo-code-form v-if="$route.path === '/checkout'"/>
								</div>
							</div>

							<!-- TAB CONTENT -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PromoCodeForm from './PromoCodeForm'

export default {
	name: 'apply-gift-card-form',
	components: {
		PromoCodeForm
	},
	data () {
		return {
			showApplyGiftCardError: false,
			giftCardValidationData: {
				giftCardNumber: '',
				giftCardPin: ''
			}
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result) {
					this.showApplyGiftCardError = false

					this.$emit('giftCardValidate', this.giftCardValidationData)
					$('#collapsegiftapply').collapse('hide')
				} else {
					this.showApplyGiftCardError = true
				}
			})
		}
	}
}
</script>

<style scoped>
</style>
